import useAxios from 'hooks/useAxios';

/**
 * Get games played statistics by game type for a date range
 * @param {Object} params - Query parameters
 * @param {string} params.startDate - Start date (ISO 8601 format)
 * @param {string} params.endDate - End date (ISO 8601 format)
 */
export async function getGamesPlayed(params = {}) {
  const api = useAxios();

  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);

    const res = await api.get(`/statistics/games-played?${queryParams.toString()}`);
    return res;
  } catch (err) {
    return err;
  }
}
